export const challengeCodeDict: Record<string, string> = {
  /* ──────────────── ENERGY & CIRCUITS ──────────────── */
  '1.0': 'Energy - Explore the Idea!',
  '2.1': 'Complete Circuit I - Explore the Idea!',
  '2.1.1': 'Complete Circuit I - Challenge 1',
  '2.1.2': 'Complete Circuit I - Challenge 2',
  '2.1.3': 'Complete Circuit I - Challenge 3',
  '2.1.4': 'Complete Circuit I - Challenge 4',
  '2.2': 'Complete Circuit II - Explore the Idea!',
  '2.2.2': 'Complete Circuit II - Challenge 1',
  '2.2.3': 'Complete Circuit II - Challenge 2',
  '2.2.4': 'Complete Circuit II - Challenge 3',
  '2.2.5': 'Complete Circuit II - Challenge 4',
  '2.2.6': 'Complete Circuit II - Challenge 5',
  '2.3': 'Short Circuits - Explore the Idea!',
  '2.2.1': 'Short Circuits - Challenge 1',
  '2.3.1': 'Short Circuits - Challenge 2',
  '2.3.2': 'Short Circuits - Challenge 3',
  '2.3.3': 'Short Circuits - Challenge 4',
  '2.4.1': 'Short Circuits - Challenge 5',
  '2.3.4': 'Short Circuits - Challenge 6',
  '2.5': 'Switches - Explore the Idea!',
  '2.5.1': 'Switches - Challenge 1',
  '2.5.2': 'Switches - Challenge 2',
  '2.5.3': 'Switches - Challenge 3',
  '2.5.4': 'Switches - Challenge 4',
  /* ──────────────── FORCES & MOTION ──────────────── */
  ETI_Force: 'Force - Explore the Idea!',
  LV_01: 'Force - Lever 1',
  LV_02: 'Force - Lever 2',
  ETI_Friction: 'Friction - Explore the Idea!',
  IP_01: 'Friction - Spring 1',
  IP_02: 'Friction - Inclined Plane 1',
  ETI_Inertia: 'Inertia - Explore the Idea!',
  PE_01: 'Inertia - Pendulum 1',
  PE_02: 'Inertia - Pendulum 2',
  SC_01: 'Inertia - Screw 1',
  SC_02: 'Inertia - Screw 2',
  ETI_Rotation: 'Rotation - Explore the Idea!',
  PU_01: 'Rotation - Pulley 1',
  WA_01: 'Rotation - Wheel and Axle 1',
  WA_02: 'Rotation - Wheel and Axle 2',
  /* ──────────────── HABITAT & ADAPTATION ──────────────── */
  ETI_Survival_And_Organism: 'Survival and Organisms - Explore the Idea!',
  BIRD_01: 'Bird - Tundra',
  REPTILE_01: 'Reptile - Grassland',
  MAMMAL_01: 'Mammal - Rainforest',
  PLANT_01: 'Plant - Desert',
  ETI_Adaptation_And_Traits: 'Adaptation and Traits - Explore the Idea!',
  BIRD_02: 'Bird - Grassland',
  REPTILE_02: 'Reptile - Tundra',
  MAMMAL_02: 'Mammal - Desert',
  PLANT_02: 'Plant - Tundra',
  ETI_Habitat_And_Resources: 'Habitat and Resources - Explore the Idea!',
  BIRD_03: 'Bird - Desert',
  REPTILE_03: 'Reptile - Rainforest',
  MAMMAL_03: 'Mammal - Tundra',
  PLANT_03: 'Plant - Grassland',
  PLANT_04: 'Plant Exhibit',
  BIRD_04: 'Bird Exhibit',
  MAMMAL_04: 'Mammal Exhibit',
  REPTILE_04: 'Reptile Exhibit',
  RAINFOREST_01: 'Rainforest Ecosystem',
  GRASSLAND_01: 'Grassland Ecosystem',
  TUNDRA_01: 'Tundra Ecosystem',
  DESERT_01: 'Desert Ecosystem',
  /* ──────────────── LIGHT & SOUND ──────────────── */
  ETI_LightWave_SoundWave: 'Explore the Idea 1',
  LS_1: 'Speaker',
  LS_2: 'Spotlight',
  ETI_Wavelength: 'Explore the Idea 2',
  WL_1: 'Color',
  WL_2: 'Pitch',
  ETI_Amplitude: 'Explore the Idea 3',
  AMP_1: 'Volume',
  AMP_2: 'Brightness',
  ETI_Absorption: 'Explore the Idea 4',
  ABS_1: 'Panel Material',
  ABS_2: 'Panel Height',
  ETI_Reflection: 'Explore the Idea 5',
  REF_1: 'Material & Angle',
  ETI_Transmission: 'Explore the Idea 6',
  TRM_1: 'Panel Material 2',
  TRM_2: 'Controller',
  /* ──────────────── MANUFACTURE & MATH ──────────────── */
  ETI_Color_And_Coordinates: 'Explore the idea 1',
  MM_1_1: 'Orange Hole',
  MM_1_2: 'Purple Hole',
  MM_1_3: 'Depot',
  ETI_System_And_Production: 'Explore the idea 2',
  MM_2_1: 'Orient the Painter',
  MM_2_2: 'Orient the Waxer',
  MM_2_3: 'Out of Sorts',
  ETI_Algorithm: 'Explore the idea 3',
  MM_3_1: 'Algorithm 1',
  MM_3_2: 'Algorithm 2',
} as const;

const challengeCodeOrderLookup = Object.keys(challengeCodeDict).reduce<
  Record<string, number>
>((acc, key, index) => {
  acc[key] = index;
  return acc;
}, {});

export const getChallengeSortOrder = (challengeCode: string) =>
  challengeCodeOrderLookup[challengeCode] ?? Number.MAX_SAFE_INTEGER;

export const translateChallengeCodeToName = (challengeCode: string) => {
  return challengeCodeDict[challengeCode] || challengeCode;
};
